import { combineReducers } from 'redux';
import authReducer from './authReducer';
import tokenReducer from './tokenReducer';
import { getEquipmentsReducer } from './equipReducers';
import shopReducer from './shopReducer';
import productReducer from './productReducer';
import chatbotReducer from './chatbotReducer'; // optional

const rootReducer = combineReducers({
  authReducer,
  tokenReducer,
  getEquipmentsReducer,
  shopReducer,
  productReducer,
  chatbotReducer // optional
});

export default rootReducer;
